export default "__VITE_ASSET__DphR90ve__"